import React from 'react';

/** Shared between the teacher's ProfileSettings.jsx and the student's
 * StudentProfileSettings.jsx — same confirm-before-sign-out prompt on
 * both, styled independently of either page's CSS (inline) so it doesn't
 * need a shared stylesheet. */
export default function ConfirmSignOutModal({ isOpen, onCancel, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 3000,
        background: 'rgba(0,0,0,0.4)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onClick={onCancel}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff', borderRadius: 12, padding: 24,
          width: '90%', maxWidth: 360,
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
        }}
      >
        <h3 style={{ margin: '0 0 8px', fontSize: 16, fontWeight: 700, color: '#1a1a1a' }}>
          Sign out?
        </h3>
        <p style={{ margin: '0 0 20px', fontSize: 13, color: '#6c757d', lineHeight: 1.5 }}>
          You'll need to sign back in to access your account.
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              padding: '10px 18px', fontSize: 14, fontWeight: 500,
              background: '#f8f9fa', color: '#6c757d',
              border: 'none', borderRadius: 8, cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '10px 18px', fontSize: 14, fontWeight: 600,
              background: '#b91c1c', color: '#fff',
              border: 'none', borderRadius: 8, cursor: 'pointer',
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
